export const DBConfig = {
    name: "dicomcache",
    version: 1,
    objectStoresMeta: [
      {
        store: "dicom",
        storeConfig: { keyPath: "id", autoIncrement: true },
        storeSchema: [
          { name: "_id", keypath: "_id", options: { unique: false } },
          { name: "data", keypath: "data", options: { unique: false } }
        ]
      }
    ]
  };
  